/**
 * Full automotive manufacturer list used by the KFZ step form ("Marke & Modell" subStep).
 * Sourced from the legacy kfzForm in data.ts (~300 entries) and externalised here so the
 * schema file stays small. "Sonstige" stays at the end as the catch-all option.
 */
export const MANUFACTURERS = [
  "9ff",
  "Abarth",
  "AC",
  "ACM",
  "Acura",
  "Aerfal",
  "Aiways",
  "Aixam",
  "Alba Mobility",
  "Alfa Romeo",
  "Alpina",
  "Alpine",
  "Amphicar",
  "Angelelli Automobili",
  "Ariel Motor",
  "Artega",
  "Aspark",
  "Aspid",
  "Aston Martin",
  "Audi",
  "Aurus",
  "Austin",
  "Austin-Healey",
  "Autobianchi",
  "BAIC",
  "BAW",
  "Bedford",
  "Bellier",
  "Bentley",
  "Bertone",
  "Bestune",
  "BMW",
  "Boldmen",
  "Bolloré",
  "Borgward",
  "Brilliance",
  "Bristol",
  "Brute",
  "Bugatti",
  "Buick",
  "BYD",
  "Cadillac",
  "Caravans-Wohnm",
  "Carver",
  "Casalini",
  "Caterham",
  "Cenntro",
  "Chamonix",
  "Changan",
  "Changhe",
  "Chatenet",
  "Chery",
  "Chevrolet",
  "Chrysler",
  "Cirelli",
  "Citroen",
  "CityEL",
  "Corvette",
  "CUPRA",
  "Dacia",
  "Daewoo",
  "DAF",
  "Daihatsu",
  "Daimler",
  "Dallara",
  "Dangel",
  "De la Chapelle",
  "De Tomaso",
  "Delorean",
  "Denza",
  "Devinci Cars",
  "DFSK",
  "Dodge",
  "Dongfeng",
  "Donkervoort",
  "DR Automobiles",
  "DS Automobiles",
  "Dutton",
  "e.GO",
  "Ebro",
  "Econelo",
  "Edran",
  "Elaris",
  "Embuggy",
  "EMC",
  "Estrima",
  "Evetta",
  "EVO",
  "Farizon",
  "Ferrari",
  "Fiat",
  "Fisker",
  "Ford",
  "Forthing",
  "Foton",
  "Gac Gonow",
  "Galloper",
  "Gappy",
  "GAZ",
  "Geely",
  "GEM",
  "GEMBALLA",
  "Genesis",
  "Giana",
  "Gillet",
  "Giotti Victoria",
  "GMC",
  "Goupil",
  "Great Wall",
  "Grecav",
  "GTA",
  "GWM",
  "Haima",
  "Hamann",
  "Haval",
  "Hiphi",
  "Holden",
  "Honda",
  "Hongqi",
  "HUMMER",
  "Hurtan",
  "Hyundai",
  "ICH-X",
  "Ineos",
  "Infiniti",
  "Innocenti",
  "Invicta",
  "Iso Rivolta",
  "Isuzu",
  "Iveco",
  "IZH",
  "JAC",
  "Jaecoo",
  "Jaguar",
  "Jeep",
  "Jensen",
  "Karma",
  "KGM",
  "Kia",
  "Koenigsegg",
  "KTM",
  "Lada",
  "Lamborghini",
  "Lancia",
  "Land Rover",
  "LDV",
  "Leapmotor",
  "Lee Group",
  "LEVC",
  "Lexus",
  "Li",
  "Lifan",
  "Ligier",
  "Lincoln",
  "Linzda",
  "Livan",
  "Lorinser",
  "Lotus",
  "Lucid",
  "Lynk & Co",
  "M-Ero",
  "Mahindra",
  "MAN",
  "Mansory",
  "Martin",
  "Martin Motors",
  "Maserati",
  "Matra",
  "Maxus",
  "Maybach",
  "Mazda",
  "McLaren",
  "Mega",
  "Melex",
  "Mercedes-Benz",
  "Mercury",
  "MG",
  "Micro",
  "Microcar",
  "Militem",
  "Minari",
  "Minauto",
  "MINI",
  "Mitsubishi",
  "Mitsuoka",
  "Mobilize",
  "Morgan",
  "Moskvich",
  "MP Lafer",
  "MPM Motors",
  "NIO",
  "Nissan",
  "NSU",
  "Oldsmobile",
  "Oldtimer",
  "Omoda",
  "Opel",
  "Ora",
  "Pagani",
  "Panther Westwinds",
  "Peugeot",
  "PGO",
  "Piaggio",
  "Plymouth",
  "Polestar",
  "Pontiac",
  "Porsche",
  "Proton",
  "Puch",
  "RAM",
  "Regis",
  "Reliant",
  "Renault",
  "Rivian",
  "Rolls-Royce",
  "Rover",
  "Ruf",
  "Saab",
  "Santana",
  "SEAT",
  "Segway",
  "Selvo",
  "Seres",
  "Sevic",
  "SGS",
  "Shelby",
  "Shuanghuan",
  "Silence",
  "Simplici",
  "Singer",
  "Skoda",
  "Skywell",
  "smart",
  "SpeedArt",
  "Sportequipe",
  "Spyker",
  "SsangYong",
  "Stormborn",
  "StreetScooter",
  "Studebaker",
  "Subaru",
  "Suzuki",
  "SWM",
  "Talbot",
  "Tasso",
  "Tata",
  "Tazzari EV",
  "TECHART",
  "Tesla",
  "Tiger",
  "Togg",
  "Town Life",
  "Toyota",
  "Trabant",
  "Trailer-Anhänger",
  "Triumph",
  "Trucks-Lkw",
  "TVR",
  "UAZ",
  "Vanden Plas",
  "Vanderhall",
  "VAZ",
  "VEM",
  "VinFast",
  "Volkswagen",
  "Volvo",
  "Voyah",
  "Wartburg",
  "Weltmeister",
  "Wenckstern",
  "Westfield",
  "Wey",
  "Wiesmann",
  "XBus",
  "XEV",
  "Xiaomi",
  "Xpeng",
  "Zastava",
  "ZAZ",
  "Zeekr",
  "Zhidou",
  "Zotye",
  "Sonstige",
] as const;
